const style: any = {
    'fontFamily': 'Roboto',
    'fontStyle': 'normal',
    'fontWeight': '700',
    'fontSize': '16px',
    'lineHeight': '24px',
    'letterSpacing': '0.15px',
    'color': '#000000',
    'textAlign': 'center'
}

type Props = {
    email: string
}

export default function HelpTitle(props: Props) {

    return (
        <div style={style}>Usuario {props.email}</div>
    );

}